import FormControl from "@mui/material/FormControl/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Radio from "@mui/material/Radio/Radio";
import RadioGroup from "@mui/material/RadioGroup/RadioGroup";
import Paper from "@mui/material/Paper/Paper";
import Divider from "@mui/material/Divider/Divider";
import Grid from "@mui/material/Grid/Grid";
import Typography from "@mui/material/Typography/Typography";
import makeStyles from "@mui/styles/makeStyles/makeStyles";

import { Chart } from "react-google-charts";
import { useEffect, useState } from "react";

const estados = [
  { uf: "AC", nome: "Acre" },
  { uf: "AL", nome: "Alagoas" },
  { uf: "AP", nome: "Amapá" },
  { uf: "AM", nome: "Amazonas" },
  { uf: "BA", nome: "Bahia" },
  { uf: "CE", nome: "Ceará" },
  { uf: "DF", nome: "Distrito Federal" },
  { uf: "ES", nome: "Espírito Santo" },
  { uf: "GO", nome: "Goiás" },
  { uf: "MA", nome: "Maranhão" },
  { uf: "MT", nome: "Mato Grosso" },
  { uf: "MS", nome: "Mato Grosso do Sul" },
  { uf: "MG", nome: "Minas Gerais" },
  { uf: "PA", nome: "Pará" },
  { uf: "PB", nome: "Paraíba" },
  { uf: "PR", nome: "Paraná" },
  { uf: "PE", nome: "Pernambuco" },
  { uf: "PI", nome: "Piauí" },
  { uf: "RJ", nome: "Rio de Janeiro" },
  { uf: "RN", nome: "Rio Grande do Norte" },
  { uf: "RS", nome: "Rio Grande do Sul" },
  { uf: "RO", nome: "Rondônia" },
  { uf: "RR", nome: "Roraima" },
  { uf: "SC", nome: "Santa Catarina" },
  { uf: "SP", nome: "São Paulo" },
  { uf: "SE", nome: "Sergipe" },
  { uf: "TO", nome: "Tocantins" },
];

const useStyles = makeStyles(() => ({
  label: { fontWeight: "700", fontSize: "1.49vh", color: "#5C5C5C" },
  card: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "4vh",
  },
  cardTitle: {
    marginInline: "4vh",
    marginTop: "4vh",
    marginBottom: "4vh",
    fontWeight: "700",
    fontSize: "1.75vh",
    color: "#5C5C5C",
  },
}));

const ConversionMapComponent = ({ counters }) => {
  const classes = useStyles();
  const [options, setOptions] = useState({});
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("Links Convertidos");

  useEffect(() => {
    if (!!counters) {
      makeOptions(counters, filter);
    }
  }, [counters]);

  const makeOptions = (counters, newFilter) => {
    setOptions({
      region: "BR",
      resolution: "provinces",
      colorAxis: { colors: ["#00853f", "black", "#e31b23"] },
      backgroundColor: "#81d4fa",
      datalessRegionColor: "#f8bbd0",
      defaultColor: "#f5f5f5",
    });

    var mapData = {};

    estados.forEach((estado) => {
      var contador = 0;
      if (newFilter == "Links Convertidos") {
        counters.usuariosMaisEngajados.linksConvertidos.forEach((item) => {
          if (
            Object.keys(item).includes("estado") &&
            item.estado == estado.uf
          ) {
            contador += parseFloat(item.producoes);
          }
        });
      } else if (newFilter == "Links Solicitados") {
        counters.usuariosMaisEngajados.linksSolicitados.forEach((item) => {
          if (
            Object.keys(item).includes("estado") &&
            item.estado == estado.uf
          ) {
            contador += parseFloat(item.solicitacoes);
          }
        });
      } else if (newFilter == "Propostas Geradas") {
        counters.usuariosMaisEngajados.propostasGeradas.forEach((item) => {
          if (
            Object.keys(item).includes("estado") &&
            item.estado == estado.uf
          ) {
            contador += parseFloat(item.propostas);
          }
        });
      } else if (newFilter == "Propostas Aprovadas") {
        counters.usuariosMaisEngajados.propostasAprovadas.forEach((item) => {
          if (
            Object.keys(item).includes("estado") &&
            item.estado == estado.uf
          ) {
            contador += parseFloat(item.propostas);
          }
        });
      }

      mapData[estado.uf] = [contador];
    });

    var newData = Object.entries(mapData).map(([key, value]) => {
      const state = estados.filter((e) => e.uf == key);
      return [state[0].nome, ...value];
    });

    setData([["Estado", newFilter], ...newData]);
  };

  const onChangeFilter = (newFilter) => {
    setFilter(newFilter);
    makeOptions(counters, newFilter);
  };

  return (
    <Paper variant="outlined" className={classes.card}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography className={classes.cardTitle}>
          ENGAJAMENTO POR ESTADO
        </Typography>
        <RadioButtonsGroup filter={filter} setFilter={onChangeFilter} />
      </div>
      <Divider />
      <div style={{ marginBottom: "1vh", padding: "1vh" }}>
        {!!counters && (
          <Chart
            chartEvents={[
              {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                  const chart = chartWrapper.getChart();
                  const selection = chart.getSelection();
                  if (selection.length === 0) return;
                },
              },
            ]}
            chartType="GeoChart"
            width="100%"
            height="45vh"
            options={options}
            data={data}
          />
        )}
      </div>
    </Paper>
  );
};

function RadioButtonsGroup({ filter, setFilter }) {
  const classes = useStyles();

  const handleChange = (event) => {
    setFilter(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <RadioGroup row value={filter} onChange={handleChange}>
        <Grid container spacing={1} style={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={3} md={3}>
            <FormControlLabel
              value="Links Convertidos"
              control={<Radio />}
              label={<span className={classes.label}>LINKS CONVERTIDOS</span>}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <FormControlLabel
              value="Links Solicitados"
              control={<Radio />}
              label={<span className={classes.label}>LINKS SOLICITADOS</span>}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <FormControlLabel
              value="Propostas Geradas"
              control={<Radio />}
              label={<span className={classes.label}>PROPOSTAS GERADAS</span>}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <FormControlLabel
              value="Propostas Aprovadas"
              control={<Radio />}
              label={<span className={classes.label}>PROPOSTAS APROVADAS</span>}
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </FormControl>
  );
}

export default ConversionMapComponent;
